<div mat-dialog-title class="acquisition-title">
  <span>{{'action.unitAcquisitionParameters' | translate}}</span>
  <span class="info-tooltip">
    <i class="fas fa-exclamation-circle fa-xs"></i>
    <span class="info-tooltip-text">{{"acquisition.msg"|translate}}</span>
  </span>
  <button mat-dialog-close>
    <i class="fa fa-times"></i>
  </button>
</div>

<mat-dialog-content>
  @if (spinner.isLoading) {
    <span class="ui-loading" [model]="spinner"></span>
  } @else {
    <form [formGroup]="form" (ngSubmit)="submitForm()">
      <div class="acquisition-row acquisition-labels">
        <span>{{'acquisition.unit' | translate}}</span>
        <span>{{'acquisition.delta' | translate}}</span>
        <span>{{'acquisition.period' | translate}}</span>
        <span class="centered">{{'acquisition.specials' | translate}}</span>
        <span class="centered">{{'acquisition.excludeSpecials' | translate}}</span>
      </div>
      <ng-container [formArrayName]="'units'">
        @for (unitForm of u.controls; track unitForm; let i = $index) {
          <div class="acquisition-row" [formGroup]="unitForm">
            <span class="acquisition-unit-name">{{unitForm.controls.name.value}}</span>
            <input [formControlName]="'delta'" type="text" class="form-control" [ngClass]="{'border-danger': unitForm.controls.delta.invalid && (unitForm.controls.delta.dirty || unitForm.controls.delta.touched)}" id="delta{{unitForm.controls.uid.value}}">
            <input [formControlName]="'period'" type="text" class="form-control" [ngClass]="{'border-danger': unitForm.controls.period.invalid && (unitForm.controls.period.dirty || unitForm.controls.period.touched)}" id="period{{unitForm.controls.uid.value}}">
            <div class="centered">
              @if (displaySpecialCount(unitForm.controls.uid.value)) {
                <span class="deviant-tags-indicator" (click)="getUnitsDeviantTagsAcquisitionParameters(unitForm.controls.uid.value, unitForm.controls.specialAcquisitionCount.value > 0)">
                  {{unitForm.controls.specialAcquisitionCount.value}}
                </span>
              }
            </div>
            <div class="centered">
              <input [formControlName]="'excludeSpecials'" type="checkbox" class="include-special-checkbox" [ngClass]="{'border-danger': unitForm.controls.excludeSpecials.invalid && (unitForm.controls.excludeSpecials.dirty || unitForm.controls.excludeSpecials.touched)}" id="excludeSpecials{{unitForm.controls.uid.value}}">
            </div>
          </div>
        }
      </ng-container>
      <div class="acquisition-btn">
        <button type="submit" class="btn_app table-action">{{"acquisition.btn"|translate}}</button>
      </div>
    </form>
  }
</mat-dialog-content>
